// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 500) return "js/500.js";
	if (chunkId === 691) return "js/691.js";
	if (chunkId === 360) return "js/360.js";
	if (chunkId === 620) return "js/620.js";
	// return url for filenames based on template
	return undefined;
};